import React from "react"
import {Box, Typography} from "@mui/material"

import type {ChannelPresenter} from "../channelPresenter"
import type {UnidentifiedMessage} from "../types"

import {DeferralReasonChip, ReceivedAgo, SourceChip, StatusChip} from "./chips"

function ItemHeader({message, presenter}: {message: UnidentifiedMessage; presenter: ChannelPresenter}) {
	return (
		<Box display="flex" flexDirection="column" gap={2} mb={4}>
			<Typography variant="h5" component="h1" fontWeight={600}>
				{presenter.title(message)}
			</Typography>
			<Box display="flex" alignItems="center" gap={2} flexWrap="wrap">
				<DeferralReasonChip reason={message.DeferralReason} />
				<SourceChip label={presenter.sourceLabel(message)} />
				<StatusChip status={message.Status} message={message} />
				<ReceivedAgo receivedAt={message.ReceivedAt} />
			</Box>
		</Box>
	)
}

export {ItemHeader}
